import { NgClass } from '@angular/common';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  computed,
  input,
  signal,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { Auction } from 'src/app/articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-article-description',
  templateUrl: './article-description.component.html',
  styleUrls: ['./article-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslatePipe, NgClass, FaIconComponent],
})
export class ArticleDescriptionComponent implements OnInit {
  isEventNow = input(false);
  selectedAuction = input<Auction>();
  isCertificatePage = input(false);
  descriptionClicked = signal(false);

  description = computed(() => {
    return (
      this.selectedAuction()?.article?.articleInfoList[0]?.description ??
      this.selectedAuction()?.article?.articleDescription
    );
  });
  notes = computed(() => {
    return this.selectedAuction()?.article?.articleInfoList[0]?.notes;
  });

  isMemorabid = computed(() => this.selectedAuction()?.idAuctionType == 1);

  constructor() {}

  ngOnInit(): void {}

  onDescription() {
    this.descriptionClicked.set(false);
  }

  onDisclaimer() {
    this.descriptionClicked.set(true);
  }
}
